import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./RenameSubscriptionForm";
import {cancelRenameSubscription} from "../../actions/AccountApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "name");
  return errors.toJS();
}


class RenameSubscriptionFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("subscriptionId", this.props.subscriptionId);
    return this.props.renameSubscription(updatedValues.toJS())
      .then((response) => {
        if (response.data.renameSubscription.errors.length <= 0) {
          this.props.cancelRenameSubscription();
        } else {
          let errors = createValidationErrors(response.data.renameSubscription.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRenameSubscription();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const RENAME_SUBSCRIPTION = gql`
  mutation renameSubscription($data: RenameSubscriptionInput!) {
    renameSubscription(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(RENAME_SUBSCRIPTION, {
    props: ({ mutate }) => ({
      renameSubscription: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelRenameSubscription})(withQueries(RenameSubscriptionFormContainer));